import { Icon } from '@billy/design-system'
import { Button } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { useBalanceLabels } from '@features/balanceLedger'

import { FooterRow } from './styles'

interface FilterChipFooterProps {
  onDelete: () => void
  onReset: () => void
}

export const FilterChipFooter = ({ onDelete, onReset }: FilterChipFooterProps): ReactElement => {
  const { bt } = useBalanceLabels()

  return (
    <FooterRow data-testid="filter-chip-footer">
      <Button
        color="danger"
        label={bt('filters.action.delete')}
        onClick={onDelete}
        startIcon={<Icon color="currentColor" icon="trash" size="sm" />}
        variant="text"
      />
      <Button
        label={bt('filters.action.reset')}
        onClick={onReset}
        startIcon={<Icon color="currentColor" icon="refresh" size="sm" />}
        variant="outlined"
      />
    </FooterRow>
  )
}
